import angular from 'angular';

import RwHomepageLinksComponent from './rw-homepage-links-component';
import { RwHomepageLinksController } from './rw-homepage-links-controller';

export default angular
  .module('rw-homepage-links', [])
  .controller('RwHomepageLinksController', RwHomepageLinksController)
  .component('rwHomepageLinks', RwHomepageLinksComponent);



// WEBPACK FOOTER //
// ./src/modules/utils/rw-homepage-links/rw-homepage-links-module.js